<template>
  <div class="dashboard-modern">
    <NavBar
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
    />

    <AuthBySessionExpired />

    <div
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
      class="container"
    >
      <div class="dashboard-header">
        <div class="header-content">
          <h1 class="page-title">Residentes</h1>
          <div class="header-stats">
            <div
              v-if="$store.state.online && duty && permission('write', 'duty')"
            >
              Plantão iniciado no dia {{ formatDate(duty.created_at) }}
              <v-btn class="btn highlighted-as-forward" @click="openModal">
                <i class="fas fa-briefcase-medical mr-2"></i>
                <span>Finalizar Plantão</span>
              </v-btn>
            </div>

            <!-- teste video AWS -->
            <div v-if="video == 'video1973'">
              <HelpVideo
                url_video="https://sistemaclin-videos-ajuda.s3.us-east-2.amazonaws.com/video-teste.mp4"
              />
            </div>

            <button
              v-if="
                residentsWithBirthday.length > 0 || usersWithBirthday.length > 0
              "
              @click="$bvModal.show('residents-and-users-birthday')"
              class="birthday-open-btn"
            >
              <i class="fas fa-birthday-cake mr-2"></i> Aniversariantes do mês
            </button>

            <v-btn
              v-if="$store.state.online && !duty && permission('write', 'duty')"
              class="btn highlighted-as-forward"
              @click="openModal"
            >
              <i class="fas fa-briefcase-medical mr-2"></i>
              Iniciar Plantão
            </v-btn>

            <div class="stat-item">
              <span class="stat-number">{{ total }}</span>
              <span class="stat-label">Total</span>
            </div>
          </div>
        </div>

        <Duty @checkPeriodDuty="checkPeriodDuty" :duty="duty" />

        <div
          v-if="!loading && missing_security_questions"
          class="security-alert mt-2"
        >
          <div class="alert-content">
            <i class="fas fa-exclamation-triangle alert-icon"></i>
            <span class="alert-text">
              Verifique as questões de segurança para liberar o acesso OFFLINE!
            </span>
            <button
              @click="
                $router.push({
                  name: 'account',
                  query: { question_answer: true },
                })
              "
              class="btn-modern btn-modern-warning"
            >
              Configurar
            </button>
          </div>
        </div>
      </div>

      <div class="filters-section" v-if="$store.state.online">
        <div class="filters-grid">
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-filter filter-icon"></i>
              Gênero
            </label>
            <v-select
              dense
              :items="genders"
              v-model="gender"
              outlined
              hide-details
              class="modern-select"
              @change="handleChangeGetResidents"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-search filter-icon"></i>
              Pesquisar
            </label>
            <v-text-field
              dense
              placeholder="Nome do residente"
              outlined
              hide-details
              v-model="name"
              class="modern-input"
              @input="handleChangeGetResidents"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-heart filter-icon"></i>
              Cuidados
            </label>
            <v-select
              dense
              :items="typesFilterByCare"
              v-model="filterCare"
              outlined
              hide-details
              class="modern-select"
              @change="handleFilterByCare"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-chart-line filter-icon"></i>
              Dependência
            </label>
            <v-select
              dense
              :items="typesFilterByGrau"
              v-model="degree_of_dependence_id"
              outlined
              hide-details
              class="modern-select"
              @change="handleChangeGetResidents"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-bed filter-icon"></i>
              Ala/Setor
            </label>
            <v-select
              v-model="ward_or_sector"
              :items="beds"
              dense
              outlined
              hide-details
              class="modern-select"
              item-value="ward_or_sector"
              :item-text="
                (value) => {
                  return value.ward_or_sector
                    ? `(ALA/Setor) ${value.ward_or_sector}`
                    : 'Não filtrar';
                }
              "
              @change="handleChangeGetResidents"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-user filter-icon"></i>
              Usuário (Fez evolução)
            </label>
            <v-select
              dense
              :items="users"
              v-model="user_evolution_id"
              outlined
              hide-details
              class="modern-select"
              item-value="id"
              item-text="name"
              @change="handleChangeGetResidents"
            />
          </div>
        </div>
      </div>

      <div class="residents-section">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <AttentionPanel v-if="$store.state.online && residents.length > 0" />

          <div class="residents-grid">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="resident-card"
              :class="{
                'resident-card--monitored':
                  resident.resident_monitored_health_problems.length > 0,
              }"
            >
              <div class="card-header" @click="handleToResident(resident.id)">
                <div class="resident-avatar">
                  <img
                    :src="
                      permission('read', 'resident_photo') && resident.photo_url
                        ? resident.photo_url
                        : require('../assets/user.png')
                    "
                    :alt="resident.name"
                    class="avatar-image"
                  />
                </div>

                <div class="resident-info">
                  <h3 class="resident-name">{{ resident.name }}</h3>
                  <p class="resident-nickname" v-if="resident.nickname">
                    {{ resident.nickname }}
                  </p>
                  <p
                    class="resident-age"
                    v-if="resident.date_of_birth && $store.state.online"
                  >
                    <i class="fas fa-map-pin"></i>
                    {{ getAge(resident.date_of_birth) }} anos
                  </p>

                  <p
                    class="resident-age"
                    v-if="resident.bed_ward_or_sector && $store.state.online"
                  >
                    <i class="fas fa-bed"></i> {{ resident.bed_ward_or_sector }}
                  </p>

                  <p
                    class="resident-prescription resident-with-prescription"
                    v-if="resident.existPrescription"
                  >
                    <i class="fas fa-check"></i> Prescrição médica diária
                  </p>
                  <p
                    class="resident-prescription resident-no-prescription d-flex align-items-center"
                    v-if="!resident.existPrescription"
                  >
                    <i class="fas fa-times mr-1"></i> Prescrição médica diária

                    <tippy
                      arrow
                      theme="light"
                      trigger="mouseenter"
                      placement="top"
                      :interactive="false"
                      @click.native.stop
                    >
                      <template v-slot:trigger>
                        <i
                          class="fas fa-question-circle care-help-icon"
                          @click.stop
                          title="O que significa isso?"
                        ></i>
                      </template>
                      <div class="care-help-tooltip">
                        <strong>Significado:</strong>
                        Residente não possui prescrição médicada
                        cadastrada/ativa.
                      </div>
                    </tippy>
                  </p>

                  <p
                    class="resident-prescription resident-with-prescription"
                    v-if="resident.existPrescriptionLongTerm"
                  >
                    <i class="fas fa-check"></i> Prescrição médica longo prazo
                  </p>

                  <p
                    class="resident-prescription resident-with-prescription"
                    v-if="resident.existPrescriptionCare"
                  >
                    <i class="fas fa-check"></i> Cuidados prescritos
                  </p>

                  <p
                    class="resident-prescription resident-no-prescription d-flex align-items-center"
                    v-if="
                      resident.rest_home_config_dashboard_show_prescription_care ==
                        'SIM' && !resident.existPrescriptionCare
                    "
                  >
                    <i class="fas fa-times mr-1"></i>
                    Cuidados prescritos

                    <tippy
                      arrow
                      theme="light"
                      trigger="mouseenter"
                      placement="top"
                      :interactive="false"
                      @click.native.stop
                    >
                      <template v-slot:trigger>
                        <i
                          class="fas fa-question-circle care-help-icon"
                          @click.stop
                          title="O que significa isso?"
                        ></i>
                      </template>
                      <div class="care-help-tooltip">
                        <strong>Significado:</strong>
                        Residente não possui prescrição de cuidados
                        cadastrada/ativa.
                      </div>
                    </tippy>
                  </p>
                </div>
              </div>

              <div class="alerts-section" v-if="$store.state.online">
                <div
                  v-if="resident.pendingChecks.length > 0"
                  class="alert-item"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-delayed-medication">
                        <i class="fas fa-capsules"></i>
                        Medicação atrasada
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicação atrasada</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecks"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="resident.pendingChecksCare.length > 0"
                  class="alert-item"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-delayed-medication">
                        <i class="fas fa-clipboard-list"></i>
                        Cuidados atrasados

                        <tippy
                          arrow
                          theme="light"
                          trigger="mouseenter"
                          placement="top"
                          :interactive="false"
                          @click.native.stop
                        >
                          <template v-slot:trigger>
                            <i
                              class="fas fa-question-circle care-help-icon"
                              @click.stop
                              title="O que significa isso?"
                            ></i>
                          </template>
                          <div class="care-help-tooltip">
                            <strong>Significado:</strong>
                            Cuidado prescrito não foi checado como executado no
                            horário.
                          </div>
                        </tippy>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Cuidados atrasados</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecksCare"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheckCare(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div v-if="resident.pendingCares.length > 0" class="alert-item">
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-warning">
                        <i class="fas fa-exclamation"></i>
                        <span>Anotação em andamento</span>

                        <tippy
                          arrow
                          theme="light"
                          trigger="mouseenter"
                          placement="top"
                          :interactive="false"
                          @click.native.stop
                        >
                          <template v-slot:trigger>
                            <i
                              class="fas fa-question-circle care-help-icon"
                              @click.stop
                              title="O que significa isso?"
                            ></i>
                          </template>
                          <div class="care-help-tooltip">
                            <strong>Significado:</strong>
                            Colaborador iniciou o registro, mas ainda não
                            finalizou.
                          </div>
                        </tippy>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Anotação em andamento</h6>
                      <div
                        v-for="(item, key) in resident.pendingCares"
                        :key="key"
                        class="tooltip-item"
                      >
                        <div class="care-info">
                          <p class="care-type">
                            {{
                              item.type == "ANNOTATION"
                                ? "ANOTAÇÃO"
                                : "SINAIS VITAIS"
                            }}
                          </p>
                          <p class="care-date">
                            {{
                              String(item.created)
                                .split("-")
                                .reverse()
                                .join("/")
                            }}
                          </p>
                          <p class="care-caregiver">{{ item.user_name }}</p>
                        </div>
                        <button
                          @click="handleToUserCare(resident.id, item.created)"
                          class="tooltip-action"
                        >
                          Acessar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="resident.pendingSemiology.length > 0"
                  class="alert-item alert-info"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-edit"></i>
                        <span>Semiologia em andamento</span>

                        <tippy
                          arrow
                          theme="light"
                          trigger="mouseenter"
                          placement="top"
                          :interactive="false"
                          @click.native.stop
                        >
                          <template v-slot:trigger>
                            <i
                              class="fas fa-question-circle care-help-icon"
                              @click.stop
                              title="O que significa isso?"
                            ></i>
                          </template>
                          <div class="care-help-tooltip">
                            <strong>Significado:</strong>
                            Formulário de semiologia foi iniciado e ainda não
                            finalizado.
                          </div>
                        </tippy>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Semiologia em andamento</h6>
                      <div
                        v-for="(item, key) in resident.pendingSemiology"
                        :key="key"
                        class="tooltip-item"
                      >
                        <div class="care-info">
                          <p class="care-date">
                            {{
                              String(item.created)
                                .split("-")
                                .reverse()
                                .join("/")
                            }}
                          </p>
                          <p class="care-caregiver">{{ item.user_name }}</p>
                        </div>
                        <button
                          @click="
                            handleToResidentBySemiology(
                              resident.id,
                              item.created
                            )
                          "
                          class="tooltip-action"
                        >
                          Finalizar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="resident.pendingChecksLongTerm.length > 0"
                  class="alert-item alert-success"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-clock"></i>
                        <span>Longo Prazo</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicamentos de Longo Prazo</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecksLongTerm"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="
                    resident.advanceNotification.data &&
                    resident.advanceNotification.count_separate > 0
                  "
                  class="alert-item"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-separate-medication">
                        <i class="fas fa-pills"></i> Separar medicação

                        <tippy
                          arrow
                          theme="light"
                          trigger="mouseenter"
                          placement="top"
                          :interactive="false"
                          @click.native.stop
                        >
                          <template v-slot:trigger>
                            <i
                              class="fas fa-question-circle care-help-icon"
                              @click.stop
                              title="O que significa isso?"
                            ></i>
                          </template>
                          <div class="care-help-tooltip">
                            <strong>Significado:</strong>
                            Indica que a medicação ainda não foi separada e
                            precisa ser preparada.
                          </div>
                        </tippy>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Separar medicamentos</h6>
                      <div class="tooltip-item">
                        <span class="tooltip-date">{{
                          formatDate(resident.advanceNotification.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(
                              resident.id,
                              resident.advanceNotification.date
                            )
                          "
                          class="tooltip-action"
                        >
                          Separar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="
                    resident.advanceNotification.data &&
                    resident.advanceNotification.count_check > 0
                  "
                  class="alert-item alert-primary"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-syringe"></i>
                        <span>Administrar medicação</span>

                        <tippy
                          arrow
                          theme="light"
                          trigger="mouseenter"
                          placement="top"
                          :interactive="false"
                          @click.native.stop
                        >
                          <template v-slot:trigger>
                            <i
                              class="fas fa-question-circle care-help-icon"
                              @click.stop
                              title="O que significa isso?"
                            ></i>
                          </template>
                          <div class="care-help-tooltip">
                            <strong>Significado:</strong>
                            Indica que a medicação já foi separada e precisa ser
                            administrada.
                          </div>
                        </tippy>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <div class="tooltip-item">
                        <span class="tooltip-date">{{
                          formatDate(resident.advanceNotification.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(
                              resident.id,
                              resident.advanceNotification.date
                            )
                          "
                          class="tooltip-action"
                        >
                          Administrar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div v-if="resident.schedules.length > 0" class="alert-item">
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-info">
                        <i class="fas fa-calendar"></i>
                        Agendamentos de hoje
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Agendamentos</h6>
                      <div
                        v-for="(item, key) in resident.schedules"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          item.schedule_type_name
                        }}</span>
                        <button
                          @click="
                            directToCalendar(
                              item.resident_id,
                              item.schedule_type_id
                            )
                          "
                          class="tooltip-action"
                        >
                          Verificar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="resident.boxs.length > 0"
                  class="alert-item alert-box"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-cube"></i>
                        BOX
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicamentos na BOX</h6>
                      <div
                        v-for="(item, key) in resident.boxs"
                        :key="key"
                        class="tooltip-item-box"
                      >
                        <span class="tooltip-box-box"
                          >({{ item.box_name }})</span
                        >
                        <span class="tooltip-box-medicine">
                          {{ item.medicine_name }}
                        </span>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- evolutions -->
                <div v-if="resident.evolutions.length > 0" class="alert-item">
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                    :onShow="(instance) => (tippyInstance = instance)"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-delayed-evolution">
                        <i class="fas fa-scroll"></i>
                        {{ resident.evolutions.length }}
                        {{
                          resident.evolutions.length == 1
                            ? "Evolução"
                            : "Evoluções"
                        }}
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Evoluções realizadas</h6>
                      <div
                        v-for="(item, key) in resident.evolutions"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date"
                          >{{ item.evolution_type }}

                          <small
                            >(<i>{{ item.user_name }}</i
                            >)</small
                          >
                        </span>
                        <small>({{ formatDate(item.created_at) }})</small>
                        <button
                          @click="showEvolution(item)"
                          class="tooltip-action"
                        >
                          Ver
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- resident_monitored_health_problems -->
                <div
                  v-if="resident.resident_monitored_health_problems.length > 0"
                  class="alert-item"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                    :onShow="(instance) => (tippyInstance = instance)"
                  >
                    <template v-slot:trigger>
                      <div
                        class="alert-badge alert-delayed-resident-monitored-health-problems"
                      >
                        <i class="fas fa-exclamation-circle"></i>
                        {{ resident.resident_monitored_health_problems.length }}
                        {{
                          resident.resident_monitored_health_problems.length ==
                          1
                            ? "Intercorrência"
                            : "Intercorrências"
                        }}
                        <strong>(Hoje)</strong>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Intercorrências registradas</h6>
                      <div
                        v-for="(
                          item, key
                        ) in resident.resident_monitored_health_problems"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date"
                          >{{
                            formatTypeResidentMonitoredHealthProblems(item.type)
                          }}

                          <small
                            >(<i>{{ item.user_name }}</i
                            >)</small
                          >
                        </span>
                        <small>({{ formatDate(item.created_at) }})</small>
                        <button
                          @click="showResidentMonitoredHealthProblems(item)"
                          class="tooltip-action"
                        >
                          Ver
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>
              </div>

              <div
                class="card-footer-actions"
                v-if="
                  resident.rest_home_config_dashboard_show_prescription_complication ==
                  'SIM'
                "
              >
                <button
                  class="btn-monitor-health"
                  @click.stop="openMonitoredHealth(resident)"
                  title="Informar intercorrência de queda"
                >
                  <i class="fas fa-edit"></i>
                  <span>Intercorrência</span>
                </button>
              </div>

              <ResidentMonitoredHealthModal
                :resident_id="resident.id"
                :resident_name="resident.name"
                @saved="getResidents"
              />
            </div>
          </div>

          <div
            v-if="!loading && residents.length == 0 && errors.length == 0"
            class="no-results"
          >
            <i class="fas fa-search no-results-icon"></i>
            <h3 class="no-results-title">Nenhum residente encontrado</h3>
            <p class="no-results-text">
              Tente ajustar os filtros para encontrar resultados
            </p>
          </div>

          <ErrorsMessages :errors="errors" />
        </b-overlay>
      </div>

      <div
        class="pagination-section"
        v-if="!loading && residents.length > 0 && $store.state.online"
      >
        <b-pagination
          v-model="page"
          :total-rows="total"
          :per-page="itemsPerPage"
          @input="getResidents()"
          class="modern-pagination"
          align="center"
        />
      </div>

      <!-- Aniversariantes -->
      <b-modal
        size="xl"
        no-close-on-backdrop
        hide-footer
        id="residents-and-users-birthday"
        modal-class="modern-duty-modal"
      >
        <template v-slot:modal-title>
          <div class="birthday-sidebar-header">
            <i class="fas fa-birthday-cake"></i>
            <h3 class="birthday-sidebar-title">Aniversariantes do Mês</h3>
          </div>
        </template>
        <div class="birthday-sidebar">
          <div class="row m-0">
            <div class="col-md-12">
              <p v-if="usersWithBirthday.length > 0" class="m-0">
                Colaboradores:
              </p>
            </div>
            <div
              class="col-md-4 p-1"
              v-for="userWithBirthday in usersWithBirthday"
              :key="`birthday-${userWithBirthday.id}`"
            >
              <div class="birthday-placeholder v-content-card">
                <div class="user-bithday-avatar-image">
                  <img
                    :src="
                      userWithBirthday.photo_url
                        ? userWithBirthday.photo_url
                        : require('../assets/user.png')
                    "
                    :alt="userWithBirthday.name"
                  />
                </div>
                <div>
                  <h3 class="user-bithday-name">
                    {{ userWithBirthday.name }}
                  </h3>
                  <p class="user-bithday-age">
                    {{ getAge(userWithBirthday.date_of_birth) }} anos
                  </p>
                  <p class="user-bithday-day">
                    Dia
                    {{ moment(userWithBirthday.date_of_birth).format("DD") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <p v-if="residentsWithBirthday.length > 0" class="m-0">
                Residentes:
              </p>
            </div>
            <div
              class="col-md-4 p-1"
              v-for="residentWithBirthday in residentsWithBirthday"
              :key="`birthday-${residentWithBirthday.id}`"
            >
              <div class="birthday-placeholder v-content-card">
                <div class="resident-bithday-avatar-image">
                  <img
                    :src="
                      residentWithBirthday.photo_url
                        ? residentWithBirthday.photo_url
                        : require('../assets/user.png')
                    "
                    :alt="residentWithBirthday.name"
                  />
                </div>
                <div>
                  <h3 class="resident-bithday-name">
                    {{ residentWithBirthday.name }}
                  </h3>
                  <p class="resident-bithday-age">
                    {{ getAge(residentWithBirthday.date_of_birth) }} anos
                  </p>
                  <p class="resident-bithday-day">
                    Dia
                    {{
                      moment(residentWithBirthday.date_of_birth).format("DD")
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

      <v-btn
        v-if="$route.query.dataOffline"
        @click="dataOffline"
        class="offline-btn"
        color="primary"
        fixed
        bottom
        right
        fab
      >
        <i class="fas fa-download"></i>
      </v-btn>
    </div>

    <Terms v-if="terms == 0" />

    <TermsGeolocation
      v-if="terms == 1 && geolocation == 1 && terms_geolocation == 0"
    />

    <ConfirmationReading
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
      @reload="reloadPage"
      :docsToRead="docsToRead"
      :onClose="false"
    />

    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="resident-evolution"
      modal-class="modern-duty-modal"
      centered
      scrollable
    >
      <template v-slot:modal-title>Evolução</template>
      <div class="container">
        <div v-if="resident_evolution">
          <p>
            Autor: <strong>{{ resident_evolution.user_name }}</strong>
          </p>
          <p>
            Tipo:
            <strong>{{ resident_evolution.evolution_type }}</strong>
          </p>
          <p>
            Texto:
            <strong>{{ resident_evolution.text }}</strong>
          </p>
          <p v-if="resident_evolution.evolution_complements.length > 0">
            Complementos:
            <br />
            <span
              v-for="complement in resident_evolution.evolution_complements"
              :key="complement.id"
              class="tooltip-item"
            >
              <strong>{{ complement.text }}</strong>
            </span>
          </p>
          <p>
            Horário:
            <strong>{{ formatDate(resident_evolution.created_at) }}</strong>
          </p>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="resident-resident-monitored-health-problems"
      modal-class="modern-duty-modal"
      centered
      scrollable
    >
      <template v-slot:modal-title>Intercorrência</template>
      <div class="container">
        <div v-if="resident_monitored_health_problems">
          <p>
            Autor:
            <strong>{{ resident_monitored_health_problems.user_name }}</strong>
          </p>
          <p>
            Tipo:
            <strong>{{
              formatTypeResidentMonitoredHealthProblems(
                resident_monitored_health_problems.type
              )
            }}</strong>
          </p>
          <p>
            Texto:
            <strong>{{ resident_monitored_health_problems.text }}</strong>
          </p>
          <p>
            Horário:
            <strong>{{
              formatDate(resident_monitored_health_problems.created_at)
            }}</strong>
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import Duty from "../templates/Dashboard/Duty";

import Terms from "../templates/User/terms";

import TermsGeolocation from "../templates/User/TermsGeolocation";

import ResidentMonitoredHealthModal from "../templates/Dashboard/ResidentMonitoredHealthModal";

import AttentionPanel from "../templates/Dashboard/AttentionPanel";

import api from "../services/api";

import { getAge } from "../lib/getAgeByDate";

import { formatDate, formatDateToUs } from "../lib/format";

import routes from "../routes";

import permission from "../lib/permission";

import { get } from "idb-keyval";

import {
  getStatic,
  userData,
  restore,
  save,
  getRestHomeSelectedFinancialAccount,
} from "../lib/functions";

import APICache from "../lib/api-cache";

import ConfirmationReading from "../templates/DocsFolder/ConfirmationReading";

import moment from "moment";

import HelpVideo from "../templates/HelpVideo/HelpVideo"; // teste video AWS

export default {
  name: "Dashboard",

  components: {
    NavBar,
    AuthBySessionExpired,
    Duty,
    ErrorsMessages,
    Terms,
    TermsGeolocation,
    ConfirmationReading,
    HelpVideo,
    ResidentMonitoredHealthModal,
    AttentionPanel,
  },

  data() {
    return {
      video: "", // teste video AWS

      users: [],

      user_evolution_id: null,

      docsToRead: [],

      tippyInstance: null,

      resident_evolution: null,

      resident_monitored_health_problems: null,

      duty: null,

      terms: 0,

      terms_geolocation: 0,

      geolocation: 0,

      rest_home_finance: 0,

      page: 1,

      total: 0,

      itemsPerPage: 30,

      name: "",

      gender: "NONE",

      filterCare: "NONE",

      degree_of_dependence_id: "NONE",

      ward_or_sector: "",

      filter: [],

      residents: [],
      residentsWithBirthday: [],
      usersWithBirthday: [],

      beds: [],

      user: {},

      missing_security_questions: false,

      typesFilterByCare: [
        { value: "NONE", text: "Todos os residentes" },
        { value: "USER", text: "Cuidados cadastrados por mim" },
        { value: "ALL", text: "Todos com cuidados pendentes" },
      ],

      typesFilterByGrau: [
        { value: "NONE", text: "Não filtrar" },
        { value: "GRAU1", text: "GRAU 1" },
        { value: "GRAU2", text: "GRAU 2" },
        { value: "GRAU3", text: "GRAU 3" },
      ],

      genders: [
        { value: "NONE", text: "TODOS" },
        { value: "FEMININO", text: "FEMININO" },
        { value: "MASCULINO", text: "MASCULINO" },
      ],

      loading: false,

      errors: [],

      showBirthdaySidebar: true,

      searchDebounceTimer: null,

      searchAbortController: null,
    };
  },

  // teste video AWS
  mounted() {
    this.video = this.$route.query.video;
  },

  created() {
    this.retrieve();

    this.checkPeriodDuty();

    this.getDocsToRead();
  },

  beforeDestroy() {
    // Evita memory leak e requisições chegando em componente já destruído
    clearTimeout(this.searchDebounceTimer);

    if (this.searchAbortController) {
      this.searchAbortController.abort();
    }
  },

  methods: {
    getRestHomeSelectedFinancialAccount,

    userData,

    permission,

    formatDate,

    formatDateToUs,

    getAge,

    moment,

    openMonitoredHealth(resident) {
      this.$bvModal.show(`monitored-health-${resident.id}`);
    },

    showEvolution(item) {
      this.resident_evolution = item;

      if (this.tippyInstance) {
        this.tippyInstance.hide();
      }

      this.$bvModal.show("resident-evolution");
    },

    showResidentMonitoredHealthProblems(item) {
      this.resident_monitored_health_problems = item;

      if (this.tippyInstance) {
        this.tippyInstance.hide();
      }

      this.$bvModal.show("resident-resident-monitored-health-problems");
    },

    formatTypeResidentMonitoredHealthProblems(type) {
      const types = {
        QUEDA: "Queda",
        ACOMPANHADO_PROBLEMA_SAUDE: "Acompanhamento de problema de saúde",
        INTERNACAO: "Internação",
        INFECCAO: "Infecção",
      };
      return types[type] || type;
    },

    async missingSecurityQuestions() {
      try {
        const response = await api.get("/rest-home/users/offline-access");
        const { error, users } = response.data;
        if (!error) {
          const { id } = await get("user");
          this.missing_security_questions = !users.some(
            (user) => user.id == id
          );
        }
      } catch (error) {
        console.log(error);
        this.missing_security_questions = false;
      }
    },

    handleFilterByCare() {
      let {
        filterCare,
        filter,
        user: { id },
      } = this;
      let residents = filter;
      if (filterCare == "ALL") {
        residents = filter.filter((obj) => obj.pendingCares.length > 0);
      }
      if (filterCare == "USER") {
        residents = filter.filter(
          (obj) =>
            obj.pendingCares.length > 0 &&
            obj.pendingCares.filter((p) => String(p.user_id).indexOf(id)) > -1
        );
      }
      this.residents = residents;
    },

    handleChangeGetResidents() {
      this.page = 1;
      this.debouncedGetResidents();
    },

    debouncedGetResidents() {
      // Cancela o timer anterior se o usuário ainda estiver digitando
      clearTimeout(this.searchDebounceTimer);

      this.searchDebounceTimer = setTimeout(() => {
        this.getResidents();
      }, 400); // 400ms é o sweet spot: rápido o suficiente, sem spam de requisições
    },

    async retrieve() {
      restore(this, "Dashboard");

      let { user } = userData();

      if (!user) {
        routes.push({ name: "sign-in" });
        return;
      }

      this.user = user;
      let {
        rest_home_finance,
        terms,
        terms_geolocation,
        geolocation,
        dashboard_monitoring,
      } = user;
      this.terms = terms;
      this.terms_geolocation = terms_geolocation;
      this.geolocation = geolocation;
      if (rest_home_finance == 1) {
        routes.push({ name: "financial", query: { nav: "overview" } });
        return;
      }
      if (dashboard_monitoring == 1) {
        routes.push({ name: "dashboard_monitoring" });
        return;
      }
      if (permission("read", "only_financial")) {
        routes.push({ name: "financial", query: { nav: "overview" } });
        return;
      }
      if (this.$store.state.online) {
        if (terms == 1) {
          let sisclindashgender = localStorage.getItem("sisclindashgender");
          if (["NONE", "FEMININO", "MASCULINO"].includes(sisclindashgender)) {
            this.gender = sisclindashgender;
          }
          this.getResidents();
          this.getUsers();
          this.offlineResidents();
          this.getAllBeds();
        }
        this.missingSecurityQuestions();
      } else {
        try {
          let { residents } = await getStatic("/offline/residents", true);
          let dataResidents = [];
          for (let resident of residents) {
            resident.advanceNotification = { data: false, date: false };
            resident.date_of_birth = null;
            resident.pendingCares = [];
            resident.pendingChecks = [];
            resident.pendingChecksLongTerm = [];
            resident.pendingSemiology = [];
            if (resident.rest_home_id == user.rest_home_id) {
              dataResidents.push(resident);
            }
          }
          this.residents = dataResidents;
        } catch (errors) {
          console.log(errors);
        }
      }
    },

    saveState() {
      save(this, "Dashboard", [
        "page",
        "name",
        "degree_of_dependence_id",
        "gender",
        "user_evolution_id",
        "ward_or_sector",
      ]);
    },

    async offlineResidents() {
      try {
        let residents_cached = localStorage.getItem("residents_cached");
        let { user } = this;
        if (!residents_cached || residents_cached != user.rest_home_id) {
          let response = await api.get("/offline/residents");
          const { error } = response.data;
          if (!error) {
            APICache.cache("/offline/residents", "dynamic", response.data);
            localStorage.setItem("residents_cached", user.rest_home_id);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getAllBeds() {
      try {
        const response = await api.get("/rest-home/bed/ward");

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = [{ id: null, ward_or_sector: "" }, ...beds];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        if (this.searchAbortController) {
          this.searchAbortController.abort();
        }

        this.searchAbortController = new AbortController();

        this.loading = true;

        let {
          page,
          itemsPerPage,
          name,
          degree_of_dependence_id,
          gender,
          user_evolution_id,
          ward_or_sector,
        } = this;

        let params = {
          page,
          itemsPerPage,
          name,
          degree_of_dependence_id,
          gender,
          user_evolution_id,
          ward_or_sector,
        };

        const response = await api.get("/rest-home/resident/dashboard", {
          params,
          signal: this.searchAbortController.signal,
        });

        const {
          residents,
          error,
          errors,
          total,
          residentsWithBirthday,
          usersWithBirthday,
          rest_home,
        } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.filter = residents;
          this.residents = residents;
          this.residentsWithBirthday = residentsWithBirthday;
          this.usersWithBirthday = usersWithBirthday;
          this.total = total;
          this.errors = [];

          sessionStorage.setItem(
            "show_user_on_print",
            rest_home.show_user_on_print
          );
        }

        localStorage.setItem("sisclindashgender", gender);

        this.saveState();

        this.loading = false;
      } catch (error) {
        this.loading = false;

        if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
          return;
        }

        console.log(error);
      }
    },

    async getUsers() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/users-actives", {
          params,
        });

        const { users } = response.data;

        this.users = [{ id: null, name: "TODOS" }, ...users];
      } catch (error) {
        console.log(error);
      }
    },

    async dataOffline() {
      try {
        await api.get("/offline/residents");
        await api.get("/offline/residents/annotations");
        await api.get("/offline/residents/vital-signs");
        await api.get("/offline/residents/checks");
        await api.get("/offline/residents/prescriptions-normal");
        await api.get("/offline/residents/prescriptions-long-term");
      } catch (error) {
        console.log(error);
      }
    },

    async checkPeriodDuty() {
      try {
        const response = await api.get("/rest-home/duty-control/period");

        const { duty } = response.data;

        this.duty = duty;
      } catch (error) {
        console.log(error);
      }
    },

    async getDocsToRead() {
      try {
        const response = await api.get("/folder/user/read-doc");

        const { docsToRead, error } = response.data;

        if (!error) {
          this.docsToRead = docsToRead;

          if (docsToRead && Object.keys(docsToRead).length > 0) {
            this.$nextTick(() => {
              this.$bvModal.show(`ConfirmationReading-${this.docsToRead.id}`);
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    reloadPage() {
      window.location.reload();
    },

    openModal() {
      this.$bvModal.show("confirmationsOfDutys");
    },

    handleToResident: (id) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "check" },
      }),

    handleToResidentByCheck: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "check", date: formatDateToUs(date) },
      }),

    handleToResidentByCheckCare: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "checkcare", date: formatDateToUs(date) },
      }),

    directToCalendar: (resident_id, schedule_type_id) =>
      routes.push({
        name: "schedule",
        query: {
          tab: "check",
          nav: "check",
          resident_id,
          schedule_type_id,
        },
      }),

    handleToUserCare: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "annotation", date: formatDateToUs(date) },
      }),

    handleToResidentBySemiology: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "semiology", date: formatDateToUs(date) },
      }),
  },
};
</script>
<style scoped>
/* Sidebar de Aniversariantes */
.birthday-sidebar {
  max-height: 70vh;
  background: #ffffff;
  overflow-x: scroll;
}

.birthday-sidebar-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.birthday-sidebar-header i {
  font-size: 24px;
}

.birthday-sidebar-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.birthday-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.birthday-placeholder {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 5px;
}

.resident-bithday-avatar-image,
.user-bithday-avatar-image {
  width: 80px;
  height: 80px;
}

.resident-bithday-avatar-image img,
.user-bithday-avatar-image img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
}

.resident-bithday-name,
.user-bithday-name {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: #1e293b;
}

.resident-bithday-age,
.user-bithday-age {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.resident-bithday-day,
.user-bithday-day {
  font-size: 12px;
  color: #444f5f;
  margin: 0;
}

/* Scrollbar personalizado */
.birthday-list::-webkit-scrollbar {
  width: 6px;
}

.birthday-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.birthday-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.birthday-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.birthday-open-btn {
  padding: 7px 24px;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-size: 14px;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

/* Botão de fechar */
.birthday-close-btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50% !important;
  background: #ef4444;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  z-index: 10;
}

.birthday-close-btn:hover {
  background: #dc2626;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.birthday-close-btn:active {
  transform: scale(0.95);
}

.birthday-close-btn i {
  font-size: 14px;
}

.card-footer-actions {
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: flex-end;
}

/* Botão "Monitorar saúde" */
.btn-monitor-health {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 8px !important;
  border: 1px solid #fcd34d; /* borda âmbar clara */
  background: #fffbeb; /* fundo amarelo bem suave */
  color: #92400e; /* texto âmbar escuro — contraste WCAG AA */
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}

.btn-monitor-health:hover {
  background: #fef3c7;
  border-color: #f59e0b;
}

.btn-monitor-health i {
  font-size: 13px;
  color: #d97706;
}

.resident-card--monitored {
  background: #fffdf0;
  border-color: #fde68a;
}

.resident-card--monitored:hover {
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.12);
}

.care-help-icon {
  font-size: 11px;
  margin-left: 4px;
  opacity: 0.75;
  cursor: help;
  vertical-align: middle;
  transition: opacity 0.15s ease;
}

.care-help-icon:hover {
  opacity: 1;
}

.care-help-tooltip {
  font-size: 12px;
  max-width: 220px;
  line-height: 1.5;
  padding: 2px 0;
  text-align: left;
  color: #1e293b;
}
</style>